import { FC, useState } from "react";
import { useFormContext } from "react-hook-form";
import { DsmButton, DsmGrid, DsmIcon } from "@dsm-dcs/design-system-react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import { FormType } from "../../common";
import { processAndStageStylesV2 } from "../../../../../../_metronic/layout";
import ReactHookDsmInput from "../../../../../modules/Helpers/ReactHookDsmInput2";
import { CSSClassesList } from "../../../../helpers/helperTypes";
import { ShrimpIntervention } from "../../../../models/Intervention/ShrimpIntervention";
import { ShrimpGrowingStageData } from "../../../../models/Baseline/ShrimpBaseline";

interface ShrimpInputDurationComponentProps {
  formType: FormType;
  fieldItemPrefix: string;
  currentStageData: ShrimpGrowingStageData;
}

const ShrimpInputDurationComponent: FC<ShrimpInputDurationComponentProps> = ({
  formType = FormType.Add,
  fieldItemPrefix,
  currentStageData,
}) => {
  const classes = processAndStageStylesV2() as CSSClassesList;
  const intl = useIntl();

  const fc = useFormContext<ShrimpIntervention>();

  return (
    <DsmGrid
      className={classes.dsmGridTwoColumnWithBorder}
      style={{ border: "0px", rowGap: "var(--dsm-spacing-px-2)" }}
    >
      <ReactHookDsmInput
        name={`${fieldItemPrefix}.stageDuration`}
        label={`${intl.formatMessage({
          id: "BASELINE.FORM.JUVENILES.SHRIMP.STAGE_DURATION",
        })}`}
        disabled
        type="number"
        adornment={intl.formatMessage({
          id: "BASELINE.FORM.JUVENILES.SHRIMP.STAGE_DURATION.ADORNMENT",
        })}
        defaultValue={currentStageData.input.stageDuration}
        tooltip={intl.formatMessage({
          id: "BASELINE.FORM.JUVENILES.SHRIMP.STAGE_DURATION.TOOLTIP",
        })}
      />
      <div />
    </DsmGrid>
  );
};

export default ShrimpInputDurationComponent;
